export interface AutomationGuide {
  alertId: string;
  slug: string;
  title: string;
  description: string;
}

const GUIDES: AutomationGuide[] = [
  {
    alertId: "alert-83e89c3f70e3",
    slug: "earnings-iv-crush-84pct",
    title: "How I Use AI to Trade Through Earnings",
    description: "The IV crush strategy this alert is based on.",
  },
  {
    alertId: "alert-ed6146b1d3f0",
    slug: "how-to-day-trade-with-ai",
    title: "How to Day Trade with AI",
    description: "The beginner swing-trade workflow this alert is based on.",
  },
  {
    alertId: "alert-9ef6f0026ff7",
    slug: "ai-options-trading-guide",
    title: "How to Trade Options with AI",
    description: "The cheap-options workflow this alert is based on.",
  },
  {
    alertId: "alert-05481a1e8c25",
    slug: "whale-watching-flow-strategy",
    title: "How I Use AI to Track Whale Trades",
    description: "The whale-flow strategy this alert is based on.",
  },
];

export function getAutomationGuideByAlertId(alertId?: string | null): AutomationGuide | null {
  if (!alertId) return null;
  return GUIDES.find((guide) => guide.alertId === alertId) ?? null;
}

export function getAutomationGuideBySlug(slug?: string | null): AutomationGuide | null {
  if (!slug) return null;
  return GUIDES.find((guide) => guide.slug === slug) ?? null;
}
